import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Navbar, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import PrivateRoute from './PrivateRoute';
import Login from './auth/Login';
import ForgottenPassword from './auth/ForgottenPassword';
import ResetPassword from './auth/ResetPassword';
import Unsubscribe from './auth/Unsubscribe';
import Register from './auth/Register';
import Impersonate from './auth/Impersonate';
import Public from './public';
import Dashboard from './dashboard';
import { initLocalizedData } from './init/actions';
import { fetchCurrentParent } from './dashboard/actions';
import { logoutUser } from './auth/actions';
import { withTranslation } from 'react-i18next';
import FontAwesome from 'react-fontawesome';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { withAnalytics } from './common/services/analyticsTracker';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import MainMenu, { AnonymousMenu } from './mainMenu';
import { changeLanguage } from './languages/actions';
import { getActiveLanguage } from './languages/reducer';
import CookieConsent from './cookieConsent/index';

class LayoutRoot extends Component {
	componentWillReceiveProps(nextProps) {
		if (!this.props.isAuthenticated && nextProps.isAuthenticated) {
			this.props.fetchCurrentParent();
		}
	}

	render() {
		const {
			t, match, initializing, isAuthenticated, currentUser, parent, logoutUser, franchisor, centers,
			languages, activeLanguage, selectLanguage,
			bookingSearch, individualConsultationSearch, warningMessages
		} = this.props;
		const logoImg = franchisor.logoUrl || require('../theme/images/logo-kindyroo.png');

		if (franchisor.theme) {
			require(`../theme/css/themes/${franchisor.theme}.css`);
		}
		const warningMessage = activeLanguage && warningMessages && warningMessages.length > 0 && warningMessages.find(w => w.culture == activeLanguage.culture)
		return <div>
			<BlockUi blocking={initializing} renderChildren={false}>
				<Navbar collapseOnSelect className='top-header'>
					<Navbar.Header>
						<Navbar.Brand style={{ height: 'auto', padding: '0' }}>
							{franchisor.logoUrl && <div className='logo-content'>
								{!isAuthenticated && franchisor.publicWebsiteUrl ? <a href={franchisor.publicWebsiteUrl}><img src={logoImg} /></a> :
									<Link to='/'><img src={logoImg} /></Link>
								}
							</div>}
						</Navbar.Brand>
						<Navbar.Toggle className='main-menu-toggle' />
					</Navbar.Header>
					<Navbar.Collapse className='main-menu'>
						{isAuthenticated && currentUser.userImpersonation && <OverlayTrigger placement='bottom' overlay={<Tooltip id='impersonateTooltip'>{t('FO_Impersonate_Tooltip')}</Tooltip>}>
							<span style={{ color: '#e83f3c', fontSize: '20px', float: 'left', marginTop: '10px' }}><FontAwesome name='user-secret' /> </span>
						</OverlayTrigger>
						}
						{isAuthenticated && <MainMenu user={currentUser} parent={parent} franchisor={franchisor} centers={centers} onLogout={logoutUser} languages={languages} activeLanguage={activeLanguage} onSelectLanguage={selectLanguage} />}
						{!isAuthenticated && <AnonymousMenu centers={centers}
							languages={languages} activeLanguage={activeLanguage} onSelectLanguage={selectLanguage}
							bookingSearch={bookingSearch}
							individualConsultationSearch={individualConsultationSearch}
							enableWorkshops={franchisor.enableWorkshops}
						/>}
					</Navbar.Collapse>
				</Navbar>
				<div className='main-content'>
					<div className='container'>
						{warningMessage && warningMessage.message && <Alert bsStyle='warning'><FontAwesome name='bullhorn' /> {warningMessage.message}</Alert>}
						<Switch>
							<Route path='/login' component={Login} />
							<Route path='/forgottenPassword' component={ForgottenPassword} />
							<Route path='/resetPassword' component={ResetPassword} />
							<Route path='/unsubscribe' component={Unsubscribe} />
							<Route path='/register' component={Register} />
							<Route path='/impersonate' component={Impersonate} />
							<Route path='/public/:page' component={Public} />
							<PrivateRoute path='/' component={Dashboard} params={match.params} />
						</Switch>
					</div>
				</div>
				<footer className='footer'>
					<div className='container'>
						<div style={{ textAlign: 'center' }}>
							<span>Powered by <a href='https://bookingautopilot.com/' target='_blank'>Booking Autopilot</a> v{franchisor.assemblyVersion}</span> | <span><Link to='/public/cookie-policy'>{t('FO_CookieBanner_CookiePolicy')}</Link></span>
						</div>
					</div>
				</footer>
			</BlockUi>
			{franchisor.enableCustomerChat && <MessengerCustomerChat
				pageId={franchisor.facebookPageId}
				themeColor='#a695c7'
				loggedInGreeting={t('FO_Chat_LoggedInGreeting')}
				loggedOutGreeting={t('FO_Chat_LoggedOutGreeting')}
			/>}
			<CookieConsent history={this.props.history} />
		</div>;
	}
}

const mapStateToProps = state => ({
	initializing: state.auth.initializing,
	currentUser: state.auth.currentUser,
	isAuthenticated: state.auth.isAuthenticated,
	franchisor: state.configuration.franchisor,
	parent: state.parent,
	centers: Object.keys(state.entities.centers).map(key => state.entities.centers[key]),
	languages: state.configuration.language,
	activeLanguage: getActiveLanguage(state.configuration.language),
	bookingSearch: state.booking.search,
	individualConsultationSearch: state.booking.individualConsultationSearch,
	warningMessages: state.configuration.warningMessages
});

export default connect(mapStateToProps, {
	fetchCurrentParent,
	logoutUser,
	selectLanguage: culture => dispatch => {
		dispatch(changeLanguage(culture));
		// reload server-side translated data
		dispatch(initLocalizedData());
	}
})(withTranslation()(withAnalytics(LayoutRoot)));